import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from './rootReducer';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { gtmMiddleware } from './middlewares/gtm-middleware';
import { gaMiddleware } from './middlewares/ga-middleware';
// import { pendoMiddleware } from './middlewares/pendo-middleware';
import { modifyApptMiddleware } from './middlewares/modify-appt-middleware';
import { clickTrackingMiddleware } from './middlewares/clickTracking-middleware';
import { clickTrackerMiddleware } from './middlewares/click-tracker';
import { oauthMiddleware } from './middlewares/oauth';
import { navigationMiddleware } from './middlewares/navigation-middleware';

export default function configureStore(initialState, history) {
  return createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(
        thunk,
        routerMiddleware(history),
        gaMiddleware,
        // pendoMiddleware,
        gtmMiddleware,
        modifyApptMiddleware,
        oauthMiddleware,
        clickTrackingMiddleware,
        clickTrackerMiddleware,
        navigationMiddleware
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js